import React, { createContext, use, useContext, useEffect, useState } from 'react';
import config from "../config/config";
import { userSession } from '../observers/userObserver';


const TooltipContext = createContext([]); // default to empty array

export const TooltipProvider = ({ children }) => {
  const [tooltips, setTooltips] = useState([]);
  useEffect(() => {
    const fetchTooltips = async () => {
      try {
        const response = await fetch(`${config["backend-url"]}/tooltips`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userSession.getToken()}`,
          },
        });
  
        const result = await response.json();
        console.log("Fetched tooltips:", result);
  
        if (response.ok) {
          setTooltips(result);
        } else {
          console.error("Failed to fetch tooltips:", result);
          setTooltips([]); // fallback to empty array
        }
      } catch (error) {
        console.error("Error fetching tooltips:", error);
        setTooltips([]);
      }
    };
  
    // ✅ call it here
    fetchTooltips();
  }, []);
  

  return (
    <TooltipContext.Provider value={tooltips}>
      {children}
    </TooltipContext.Provider>
  );
};

// ✅ This hook now always returns an array
export const useTooltips = () => {
  return useContext(TooltipContext) || [];
};